import DayJSAdapter from '@date-io/dayjs';
import '@mdi/font/css/materialdesignicons.css';
import { createVuetify } from 'vuetify';
import { aliases, mdi } from 'vuetify/iconsets/mdi';
import 'vuetify/styles';

export default defineNuxtPlugin((nuxtApp) => {
  const vuetify = createVuetify({
    ssr: true,
    date: {
      adapter: DayJSAdapter,
    },

    icons: {
      defaultSet: 'mdi',
      aliases,
      sets: {
        mdi,
      },
    },
    theme: {
      defaultTheme: 'light',
      themes: {
        light: {
          colors: {
            // Brand colors
            primary: '#FFDF27',
            secondary: '#01011D',
            'brand-default': '#FFDF27',
            'brand-shade-01': '#C9AE1B',
            'brand-shade-02': '#FFF9D6',
            'brand-shade-03': '#FFFCE9',
            'brand-shade-04': '#FFFEF5',
            'brand-shade-05': '#C9AE1B',

            // Background/Surface colors
            background: '#FFFFFF',
            'background-2': '#F7F7F9',
            'background-3': '#E6E6E8',
            'background-fields': '#ECECEE',
            'background-disabled': '#9E9E9E',
            'background-inverted': '#01011D',
            surface: '#FFFFFF',

            // Dark navy colors
            'dark-navy': '#01011D',
            'dark-navy-light': '#1A1A34',

            // Border colors
            'border-default': '#E6E6E8',
            'border-disabled': '#ECECEE',
            'border-secondary': '#414156',
            'border-inverted': '#FFFFFF',

            // Text colors
            'text-primary': '#01011D',
            'text-secondary': '#414156',
            'text-tertiary': '#80808E',
            'text-disabled': '#B3B3B9',
            'text-inverted': '#FFFFFF',
            'text-white': '#FFFFFF',
            'text-default': '#FFDF27',

            // Icon colors
            'icon-default': '#01011D',
            'icon-secondary': '#414156',
            'icon-tertiary': '#80808E',
            'icon-disabled': '#B3B3B9',
            'icon-inverted': '#FFFFFF',
            'icon-white': '#FFFFFF',

            // Complementary colors
            'complementary-default': '#4A90E2',
            'complementary-shade-01': '#7CB3E9',
            'complementary-shade-02': '#D6E8F7',
            'complementary-shade-03': '#EBF4FB',

            // Semantic colors - Success
            success: '#458C03',
            'success-default': '#458C03',
            'success-shade-01': '#E8F5E9',
            'success-shade-02': '#1B4D0A',

            // Semantic colors - Info
            info: '#00B2F4',
            'info-default': '#00B2F4',
            'info-shade-01': '#CCF0FF',
            'info-shade-02': '#004D66',

            // Semantic colors - Warning
            warning: '#FF9800',
            'warning-default': '#FF9800',
            'warning-shade-01': '#FFF3E0',
            'warning-shade-02': '#4E2A00',

            // Semantic colors - Error
            error: '#ED1C24',
            'error-default': '#ED1C24',
            'error-shade-01': '#FFEBEE',
            'error-shade-02': '#4A0004',
          },
        },
      },
    },
    typography: {
      fontFamily: '"Urbanist", sans-serif',
    },
    defaults: {
      global: {
        ripple: false,
      },
      VBtn: {
        rounded: 'pill',
        class: 'text-capitalize',
        flat: true,
        style: 'font-family: "Urbanist", sans-serif; font-weight: 600;',
      },
      VTextField: {
        class: 'bordered-input',
        style: 'font-family: "Urbanist", sans-serif;',
      },
      VCard: {
        style: 'border-radius: 16px;',
      },
      VCardTitle: {
        style: 'font-family: "Be Vietnam Pro", sans-serif; font-weight: 700;',
      },
      VCardText: {
        style: 'font-family: "Urbanist", sans-serif;',
      },
      VSheet: {
        style: 'font-family: "Urbanist", sans-serif;',
      },
      VChip: {
        style: 'font-family: "Urbanist", sans-serif;',
      },
      VTooltip: {
        style: 'font-family: "Urbanist", sans-serif;',
      },
      VList: {
        style: 'font-family: "Urbanist", sans-serif;',
      },
      VListItem: {
        style: 'font-family: "Urbanist", sans-serif;',
      },
      VNavigationDrawer: {
        style: 'font-family: "Urbanist", sans-serif;',
      },
      VToolbar: {
        style: 'font-family: "Urbanist", sans-serif;',
      },
      VAppBar: {
        style: 'font-family: "Urbanist", sans-serif;',
      },
    },
  });

  nuxtApp.vueApp.use(vuetify);
});
